export enum AccountType {
  PRIVATE = 'PRIVATE',
  ENTERPRISE = 'ENTERPRISE'
}
